import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import { maxValue, minValue } from 'App/KYC/MissingInformation/Steps/FundsRange/formData'

export default class Slider extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    errorMessage: PropTypes.object,
    disabled: PropTypes.bool,
    fieldName: PropTypes.string,
  }

  onChange(value) {
    this.props.onChange(parseInt(value, 10))
  }

  onFocus(target) {
    target.classList.add('slider--active')
  }

  onClick(target) {
    target.blur()
    target.classList.remove('slider--active')
  }

  render() {
    return (
      <div className={styles.container}>
        <input
          type="range"
          min={minValue}
          max={maxValue}
          onChange={event => this.onChange(event.target.value)}
          onFocus={event => this.onFocus(event.target)}
          onClick={event => this.onClick(event.target)}
          value={this.props.value}
          className={styles.slider}
          style={{
            backgroundSize:
              ((this.props.value - minValue) * 100) / (maxValue - minValue) + '% 100%',
          }}
        />
        <div className={styles.osInputError}>{this.props.errorMessage}</div>
      </div>
    )
  }
}
